import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { JitsiMeeting } from "@jitsi/react-sdk";

import css from "./AdminPage.module.css";
import { Head } from "../../utils/Head";
import { UserContext } from "../../context/UserContext";

export const MeetingDetails = () => {
  const { userData } = useContext(UserContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [meeting, setMeeting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joinMode, setJoinMode] = useState(false);
  const [notes, setNotes] = useState("");
  const [savingNotes, setSavingNotes] = useState(false);

  useEffect(() => {
    async function fetchMeeting() {
      try {
        const docRef = doc(db, "meetings", id);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          const data = snapshot.data();
          setMeeting(data);
          setNotes(data.notes || ""); // carrega notas existentes
        } else {
          alert("Reunião não encontrada.");
          navigate("/admin");
        }
      } catch (error) {
        console.error("Erro ao buscar reunião:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchMeeting();
  }, [id, navigate]);

  async function handleCompleteMeeting() {
    try {
      const docRef = doc(db, "meetings", id);
      await updateDoc(docRef, { status: "completed" });
      setMeeting((prev) => ({ ...prev, status: "completed" }));
      alert("Reunião marcada como concluída!");
    } catch (error) {
      console.error("Erro ao atualizar status:", error);
    }
  }

  async function handleSaveNotes() {
    if (!notes.trim()) return alert("As notas estão vazias.");

    try {
      setSavingNotes(true);
      const docRef = doc(db, "meetings", id);
      await updateDoc(docRef, {
        notes,
        lastEditedBy: userData?.id || "admin",
        lastEditedAt: Date.now(),
      });
      alert("Notas salvas com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar notas:", error);
      alert("Erro ao salvar notas.");
    } finally {
      setSavingNotes(false);
    }
  }

  if (loading) return <p>Carregando...</p>;

  if (joinMode && meeting) {
    // 🔹 Tela da videoconferência Jitsi
    return (
      <div className={css.jitsiContainer}>
        <JitsiMeeting
          roomName={meeting.jitsiRoomName}
          configOverwrite={{
            prejoinPageEnabled: true,
            disableModeratorIndicator: false,
          }}
          interfaceConfigOverwrite={{
            SHOW_JITSI_WATERMARK: false,
            TOOLBAR_BUTTONS:
              userData.member === "admin"
                ? [
                    "microphone",
                    "camera",
                    "desktop",
                    "chat",
                    "participants-pane",
                    "mute-everyone",
                    "hangup",
                  ]
                : [
                    "microphone",
                    "camera",
                    "chat",
                    "participants-pane",
                    "hangup",
                  ],
          }}
          getIFrameRef={(node) => (node.style.height = "100vh")}
          userInfo={{
            displayName: "Admin - Ibhava",
          }}
        />
      </div>
    );
  }

  return (
    <div className={css.container}>
      <Head title={meeting.title} description="Detalhes da reunião - Ibhava" />

      <h2>{meeting.title}</h2>
      <p>
        <strong>Data:</strong>{" "}
        {new Date(meeting.scheduleFor).toLocaleString("pt-BR")}
      </p>
      <p>
        <strong>Status:</strong> {meeting.status}
      </p>
      <p>
        <strong>ID da sala:</strong> {meeting.jitsiRoomName}
      </p>

      {meeting.participants?.length > 0 && (
        <>
          <strong>Participantes:</strong>
          <ul>
            {meeting.participants.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
        </>
      )}

      {/* 🔹 SEÇÃO DE NOTAS */}
      <div className={css.notesSection}>
        <h3>📝 Notas pós-reunião</h3>
        <textarea
          className={css.notesArea}
          rows={8}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Escreva aqui suas observações, decisões e reflexões do grupo..."
        />
        <button
          className={css.saveButton}
          onClick={handleSaveNotes}
          disabled={savingNotes}
        >
          {savingNotes ? "Salvando..." : "💾 Salvar notas"}
        </button>
      </div>

      <div className={css.actions}>
        <button className="saveButton" onClick={() => setJoinMode(true)}>
          Entrar na sala
        </button>

        {meeting.status !== "completed" && (
          <button
            className={css.completeButton}
            onClick={handleCompleteMeeting}
          >
            Marcar como concluída
          </button>
        )}
      </div>
    </div>
  );
};
